import { render, staticRenderFns } from "./BillDetail.vue?vue&type=template&id=4174e837&scoped=true"
import script from "./BillDetail.vue?vue&type=script&lang=js"
export * from "./BillDetail.vue?vue&type=script&lang=js"
import style0 from "./BillDetail.vue?vue&type=style&index=0&id=4174e837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4174e837",
  null
  
)

export default component.exports